import "core-js/modules/es.string.link.js";
import ModalWrapper from '@/shared/ui/modals/ModalWrapper';
export default {
  name: 'IframeModal',
  components: {
    ModalWrapper: ModalWrapper
  },
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    visible: Boolean
  },
  data: function data() {
    return {
      isVisibleContent: false,
      interval: null
    };
  },
  computed: {
    tag: function tag() {
      var _this$data;
      return ((_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.tag) || 'iframe';
    },
    url: function url() {
      var _this$data2;
      return (_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : _this$data2.link;
    },
    classList: function classList() {
      return [this.tag];
    }
  },
  watch: {
    visible: function visible(val) {
      if (!val) {
        this.$emit('after-leave');
      }
    }
  }
};